import { render, staticRenderFns } from "./onlineWithdrawalFormPage.vue?vue&type=template&id=582bfcdb"
import script from "./onlineWithdrawalFormPage.vue?vue&type=script&lang=js"
export * from "./onlineWithdrawalFormPage.vue?vue&type=script&lang=js"
import style0 from "./onlineWithdrawalFormPage.vue?vue&type=style&index=0&id=582bfcdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports